import { DetailCard } from '@/common/components/detail-card/DetailCard.tsx';
import { Trans } from '@lingui/react/macro';

export interface NotesCardProps {
  note: string;
}

export const NotesCard = ({ note }: NotesCardProps) => {
  return <DetailCard title={<Trans>Notes</Trans>}>{note}</DetailCard>;
};
